import React, { useState } from 'react';

import RequestService from "../../services/request.service";
import AuthService from '../../features/auth/auth.service';

import { Button, Modal, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import Dialog from '../../services/Dialogs'


import { SERVER_ } from  '../../config';

const ModalGestionNumeroEmpleado = (params: any) => {


  const dialog = new Dialog();


  const user = AuthService.getCurrentUser();
  const { show, handleClose, empleado } = params;

  const [nuevosNumerosTexto, setNuevosNumerosTexto] = useState<any>( empleado.otros_numeros_empleados ? empleado.otros_numeros_empleados.join('\n') : '' );


const handleGuardar = async(e:any) => {
    try{

        await dialog.open({
          accept: 'Si',
          cancel: 'No',
          dialogClass: '',
          message: '¿Estás seguro?',
          target: e.target,
          template: ` `
        })
        let dialogo : any = await dialog.waitForUser()
        
        if(dialogo){

    const numerosArray = nuevosNumerosTexto
      .split('\n')
      .map((num:any) => num.trim())
      .filter((num:any) => num.length > 0);


          let res = await RequestService.update(`empleados/actualizar_otros_numeros_empleados/${empleado.uuid_ciudadano}`, { otros_numeros_empleados : numerosArray } )
          if(res.data){
            toast.success('Se actualizo el estatus del Trámite')
            handleClose();
          }
          
        }

    }
    catch(e){
      toast.error('Tuvimos problemas')
    }

  }


  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Gestión de Número de Empleado</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {
            // JSON.stringify( empleado.otros_numeros_empleados )
          }

          <p className="nm text-center">
            <img
              src={`${SERVER_}empleados/foto/${empleado.uuid_ciudadano}?${Math.random().toString(36).substr(2, 9)}`}
              style={{ width: '30%' }}
              alt="Empleado"
            />
          </p>
          <h5 className="text-center">
            {empleado.nombres} {empleado.paterno} {empleado.materno}
          </h5>
          <h4 className="text-center">{empleado.numero_empleado}</h4>

          <hr />



          <Form.Group controlId="nuevosNumerosEmpleado">
            <Form.Label>Agregar nuevos números de empleado (uno por línea):</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={nuevosNumerosTexto}
              onChange={(e) => setNuevosNumerosTexto(e.target.value)}
            />
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleGuardar}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalGestionNumeroEmpleado;
